import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _assign from 'lodash/assign';
import _isEmpty from 'lodash/isEmpty';
import { Content } from './Content';
import MobileToolbarContainer from './MobileToolbar/MobileToolbarContainer';

class App extends Component {
  componentDidMount() {
    this.analytics();
    this.props.history.listen(this.props.changedHistory);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pageTitle !== this.props.pageTitle) {
      document.title = this.props.pageTitle;
      const description = document.querySelector('meta[name="description"]');
      description.content = this.props.pageDescription;
    }
  }

  render() {
    const { isMobile, mapView, takeover, employerId, templatesByOrg, primaryColor, secondaryColor, noAds } = this.props;
    
    let { appClass } = templatesByOrg[employerId] || {};
    if (primaryColor || secondaryColor) appClass = 'custom-colored-embed';

    const className = classNames('dark-view', {
      'device-mobile js-device-mobile': isMobile,
      [appClass]: !!appClass
    });
    const mainClassName = classNames({
      'map-view': mapView
    });
    return (
      <div className={className}>
        <main className={mainClassName}>
          <Content />
          {isMobile && <MobileToolbarContainer />}
          {
            !isMobile && !noAds && takeover &&
              takeover.map((_takeover, i) =>
                <div key={i} className="t-search-takeover l-advert">
                  <div className="t-takeover"></div>
                </div>
              )
          }
        </main>
      </div>
    );
  }

  analytics(mzDataset = {}) {
    ((w, { referrer }) => {
      if (w._mz && w._mze) {
        const mzData = Object.assign({}, w.TES.pageMetadata);
        if (mzData.facets && this.props) {
          mzData.facets.viewType = this.props.viewType;
          w._mz.pageMetadata = _assign(w.TES.pageMetadata, !w._mz.pageMetadata || _isEmpty(w._mz.pageMetadata.referrer) ?
            { referrer: mzDataset } :
            { referrer: w._mz.pageMetadata.referrer }
          );
        }
        
        w._mz.emit(w._mze.PAGE_VIEW, { documentReferrer: referrer }, () => {});
      }
    })(window, document);
  }
}

App.propTypes = {
  isMobile: PropTypes.bool,
  i18n: PropTypes.object,
  loading: PropTypes.bool,
  mapView: PropTypes.bool,
  takeover: PropTypes.array,
  mzData: PropTypes.object,
  viewType: PropTypes.string,
  setLoading: PropTypes.func,
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired
  }).isRequired,
  changedHistory: PropTypes.func.isRequired,
  pageTitle: PropTypes.string,
  pageDescription: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string
};

export default App;
